import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, NumbersPath } from 'entities/ExportRouters'

export const NumbersSubscriptionCanceledLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.numbers_settings_subscription_canceled}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: `/${NumbersPath.root}`,
        })
      }}
    />
  )
})
